import { c as _c } from "react/compiler-runtime";
import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { LuCheck, LuFlag, LuPencil, LuStar } from 'react-icons/lu';
export const CheckRow: React.FC<{
  children: React.ReactNode;
  icon?: React.ElementType;
}> = t0 => {
  const $ = _c(8);
  const {
    children,
    icon: t1
  } = t0;
  const IconComponent = t1 === undefined ? LuCheck : t1;
  let t2;
  if ($[0] !== IconComponent) {
    t2 = <Icon asChild={true} boxSize={4} color="orange.fg" flexShrink={0} marginTop="2px"><IconComponent strokeWidth={2.5} /></Icon>;
    $[0] = IconComponent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["sm", "md"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <Text color="fg" fontSize={t3} fontWeight="medium">{children}</Text>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <HStack align="flex-start" color="fg" gap={2.5}>{t2}{t4}</HStack>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const ProofStats: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HStack align="stretch" alignSelf="stretch" bg="bg.subtle" borderColor="border" borderRadius="lg" borderWidth="1px" gap={0} overflow="hidden" width="full">{[{
        n: "10,000+",
        l: "Decks Analyzed"
      }, {
        n: "$20B+",
        l: "Raised"
      }].map(_temp)}</HStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const AccentHeading: React.FC<{
  line1: string;
  accent?: string;
  line2?: string;
  centered?: boolean;
}> = t0 => {
  const $ = _c(8);
  const {
    line1,
    accent,
    line2,
    centered: t1
  } = t0;
  const centered = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["xl", "2xl", "3xl"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = centered ? "center" : "start";
  let t4;
  if ($[1] !== accent || $[2] !== line2) {
    t4 = accent != null && <>{" "}<Box as="span" color="colorPalette.fg" colorPalette="orange">{accent}</Box>{line2 ? ` ${line2}` : null}</>;
    $[1] = accent;
    $[2] = line2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== line1 || $[5] !== t3 || $[6] !== t4) {
    t5 = <Text as="h3" fontSize={t2} fontWeight="semibold" letterSpacing="tight" lineHeight="shorter" textAlign={t3}>{line1}{t4}</Text>;
    $[4] = line1;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const WhyWeAsk: React.FC<{
  title?: string;
  items: Array<{
    icon?: React.ElementType;
    text: React.ReactNode;
  }>;
}> = t0 => {
  const $ = _c(9);
  const {
    title: t1,
    items
  } = t0;
  const title = t1 === undefined ? "Here\u2019s what you get" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <Text color="fg.subtle" fontSize="sm" fontWeight="bold" letterSpacing="0.1em" textAlign="start" textTransform="uppercase">{title}</Text>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp2);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <VStack align="stretch" gap={2}>{t3}</VStack>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <VStack align="stretch" alignSelf="stretch" gap={4}>{t2}{t4}</VStack>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const Panel: React.FC<{
  children: React.ReactNode;
  align?: 'center' | 'start';
}> = t0 => {
  const $ = _c(6);
  const {
    children,
    align: t1
  } = t0;
  const align = t1 === undefined ? "center" : t1;
  const t2 = align === "center" ? "stretch" : "stretch";
  const t3 = align === "center" ? "center" : "flex-start";
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [4, 5];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = align === "center" ? "center" : "left";
  let t6;
  if ($[1] !== children || $[2] !== t2 || $[3] !== t3 || $[4] !== t5) {
    t6 = <VStack align={t2} bgColor="colorPalette.card/50" borderColor="colorPalette.border" borderRadius="xl" borderWidth="1px" flex={1} gap={3} justify={t3} padding={t4} textAlign={t5}>{children}</VStack>;
    $[1] = children;
    $[2] = t2;
    $[3] = t3;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export const UPLOAD_OUTCOMES = [{
  icon: LuStar,
  text: 'Real-world deck audit, not AI slop'
}, {
  icon: LuFlag,
  text: 'Specific investor objections'
}, {
  icon: LuPencil,
  text: 'Step-by-step immediate fixes'
}] as const;
export const REGISTER_PERKS = ['Investor-grade score for every slide', 'Specific objections and paste-ready rewrites', 'Walk through every fix in the auditor'] as const;
function _temp(stat) {
  return <VStack key={stat.l} _last={{
    borderRightWidth: 0
  }} borderColor="border" borderRightWidth="1px" gap={0} paddingX={5} paddingY={2.5} width="full"><Text fontSize="2xl" fontWeight="extrabold" letterSpacing="tight">{stat.n}</Text><Text color="fg.subtle" fontSize="xs" fontWeight="bold" letterSpacing="wider" textTransform="uppercase">{stat.l}</Text></VStack>;
}
function _temp2(item, i) {
  return <CheckRow key={i} icon={item.icon}>{item.text}</CheckRow>;
}